import * as Yup from "yup";
import { isAfter, isBefore, parse } from "date-fns";



const getDailySlotsValidationSchema = () => {
    return (
        Yup.array()
            .when('$isLimitedConfigs', {
                is: true,
                then: Yup.array(),
                otherwise: Yup.array().of(
                    Yup.string()
                        .nullable()
                        .max(12, 'Incorrect time format - max 12 chars')
                        .matches(
                            /^(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])$/,
                            'Incorrect time format',
                        )
                )
            })
    )
}

export const availabilitySlotsValidationSchema = () => {
    return Yup.object().shape({
        monday: getDailySlotsValidationSchema(),
        tuesday: getDailySlotsValidationSchema(),
        wednesday: getDailySlotsValidationSchema(),
        thursday: getDailySlotsValidationSchema(),
        friday: getDailySlotsValidationSchema(),
        saturday: getDailySlotsValidationSchema(),
        sunday: getDailySlotsValidationSchema(),
    })
}

/**
 * To be called when directly validating the availability data
 * (in addition to Yup validation)
 * @param input
 * @returns {{}|boolean}
 */
export const validateTimeRange = (input) => {

    if (!input || !Object.keys(input).length) {
        return true;
    }

    const errors = {};

    Object.keys(input).map(day => {
        if (input[day]) {
            let ranges = input[day];

            if (!Array.isArray(input[day])) {
                ranges = input[day].split(/[,|\n]\s?/);
            }

            if (ranges.filter(range => range).length === 0) {
                return true;
            }

            // Check incorrect time formats
            let incorrectFormats = ranges.filter(range => range.trim() != '' && !range.trim().match(/^(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])$/));

            // Ensure start is before end
            let incorrectOrder = ranges.filter(range => {
                // If the range is in the wrong format, then skip this test
                if (incorrectFormats.includes(range)) {
                    return false;
                }

                let [ rangeStart, rangeEnd ] = range.split('-');

                if (!rangeStart || !rangeEnd) {
                    return false;
                }

                let startTime = parse(rangeStart.trim(), 'HH:mm', new Date());
                let endTime = parse(rangeEnd.trim(), 'HH:mm', new Date());

                return !isAfter(endTime, startTime);
            });

            let overlaps = [];
            if (ranges.length > 1) {
                overlaps = ranges.filter((range, index) => {
                    let otherRanges = ranges.filter(r => r != range);

                    let [ rangeStart, rangeEnd ] = range.split('-');

                    if (!rangeStart || !rangeEnd) {
                        return false;
                    }

                    let startTime = parse(rangeStart.trim(), 'HH:mm', new Date());
                    let endTime = parse(rangeEnd.trim(), 'HH:mm', new Date());

                    return otherRanges.filter(sRange => {
                        let [ sRangeStart, sRangeEnd ] = sRange.split('-');

                        if (!sRangeStart || !sRangeEnd) {
                            return false;
                        }

                        let sRangeStartTime = parse(sRangeStart.trim(), 'HH:mm', new Date());
                        let sRangeEndTime = parse(sRangeEnd.trim(), 'HH:mm', new Date());

                        return (isAfter(sRangeStartTime, startTime) && isBefore(sRangeStartTime, endTime)) ||
                            (isAfter(sRangeEndTime, startTime) && isBefore(sRangeEndTime, endTime)) ||
                            (isBefore(sRangeStartTime, startTime) && isAfter(sRangeEndTime, endTime))

                    }).length > 0;
                });
            }

            if (incorrectFormats.length > 0 || incorrectOrder.length > 0 || overlaps.length > 0) {
                errors[day] = [];

                if (incorrectFormats.length > 0) {
                    errors[day].push('Format error: ' + incorrectFormats.join(', '));
                }

                if (incorrectOrder.length > 0) {
                    errors[day].push('Range error: ' + incorrectOrder.join(', '));
                }

                if (overlaps.length > 0) {
                    errors[day].push('Overlapping ranges: ' + overlaps.join(', '));
                }
            }
        }
    })
    return errors;
}
